import styled from "styled-components";

const PageBreak = styled.hr`
  margin: 4rem 0;
`;

export default PageBreak;
